<template lang="pug">
  .boxExpanded
    .table-payments(@click="setExpanded")
      vm-table(:data="invoice" width="100%")
        template(slot="thead")
          vm-th
        template(slot-scope="{data}")
          vm-tr
            vm-td
              vm-icon(:icon="expandedFlag ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'")
            vm-td
              span {{ $t('invoices.folio') }}: {{ invoice.folio }}
            vm-td
              span {{ $t('invoices.invoice_date') }}: {{ invoice.invoice_date }}
            vm-td
              span {{ $t('invoices.amount') }}: {{ invoice.amount | currency }}
            vm-td
              span {{ $t('invoices.balance') }}:
              span.color-red  {{ totalRestante | currency }}
            vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="$emit('add-payment', invoice)")
                    vm-icon(icon="plus-outline")
                    slot &nbsp;{{ $t('strings.add_payment') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="$emit('view-invoice', invoice)")
                    vm-icon(icon="eye-outline")
                    slot &nbsp;{{ $t('strings.view') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="$emit('view-attachment-invoice', invoice.attachment)")
                    vm-icon(icon="attach-2-outline")
                    slot &nbsp;{{ $t('strings.attachment') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="payments.length == 0 && $auth.check('Admin')" @click="$emit('edit-invoice', invoice)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="$emit('delete-invoice', invoice)")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
    div(v-if="expandedFlag")
      .table
        vm-table(:data="payments")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsPayment") {{ $t('payments.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsPayment")
                slot(v-if="column !== 'amount'") {{ data[indextr][column] }}
                slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
              vm-td
              .icon-btn(@click="$emit('view-attachment-payment', data[indextr]['attachment'])")
                vm-icon(icon="file-text-outline" color="gray")
              vm-td
              .icon-btn(@click="$emit('edit-payment', data[indextr], invoice)")
                vm-icon(icon="edit-2-outline" color="gray")
              vm-td
              .icon-btn(@click="deletePayment(data[indextr]['id'])")
                vm-icon(icon="trash-2-outline" color="gray")
      .prices
        .card-prices
          span {{$t('invoices.total')}}
          span.span-color  {{ invoice.amount | currency }}
        .card-prices-green
          span {{$t('invoices.paidout')}}
          span.span-color-green  {{ invoice.balance | currency }}
        .card-prices
          span {{$t('invoices.remaining')}}
          span.span-color  {{ totalRestante | currency }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('InOrders')
export default {
  name: 'Expanded',
  data: () => ({
    expandedFlag: false,
    columnsPayment: [
      'payment_number',
      'date_pay',
      'amount'
    ]
  }),
  props: {
    invoice: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'inOrder'
    ]),
    payments () {
      return this.invoice.payments
    },
    totalRestante () {
      let total = this.invoice.payments.reduce((prev, cur) => prev + parseFloat(cur.amount), 0).toFixed(2)
      return (this.invoice.amount - total).toFixed(2)
    }
  },
  methods: {
    openViewer (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    setExpanded () {
      this.expandedFlag = !this.expandedFlag
    },
    deletePayment (id) {
      this.expandedFlag = false
      this.$emit('delete-payment', id)
    }
  }
}
</script>
<style lang="scss" scoped>
.boxExpanded {
  .color-red {
    color: red;
  }
  .table-payments {
    width: 100% !important;
  }
  .table {
    width: 80%;
    float: left;
  }
  .prices {
    width: 20%;
    float: left;
    align-self: center;
    margin: 20px 0px;
  }
  .card-prices {
    font-size: 12px;
    border: 1px solid rgba(var(--primary),1);
    border-radius: 10px;
    margin: 7px 5px;
    padding: 3px 10px;
  }
  .card-prices-green {
    font-size: 12px;
    border: 1.5px solid green;
    border-radius: 10px;
    margin: 7px 5px;
    padding: 3px 10px;
  }
  .span-color {
    color:  rgba(var(--primary),1);
    font-weight: bold;
  }
  .span-color-green {
    color: green !important;
    font-weight: bold;
  }
}
.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: rgb(231, 231, 231);
  }
}
</style>
